
import Vue from 'vue'
import { normalizeNumber } from '@/common/utils/common'

export default Vue.extend({
  props: {
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: Number,
      required: false,
      default: 0
    },
    maxValue: {
      type: Number,
      required: false,
      default: 999999
    }
  },
  data(): {
    maxValueKey: number
  } {
    return {
      maxValueKey: 0
    }
  },
  computed: {
    inputValue(): number {
      return this.maxValue ? this.value > this.maxValue ? this.maxValue : this.value : this.value
    },
    validateInput(): number | undefined {
      return (this.value === 0 ) ? undefined : this.inputValue
    },
    validateNaNInput(): number | string {
      return isNaN(this.value) ? this.$refs.numberInput?.value : this.validateInput
    },
    hasError(): boolean {
      return isNaN(this.value == undefined ? 0 : this.value)
    }
  },
  methods: {
    maxValidate(value: any): any {
      if (!isNaN(value)) {
        if (value > this.maxValue) {
          this.maxValueKey = this.maxValueKey + 1
          return this.maxValue
        }
          else return value
      }
      else return value
    },
    formatInput(input: any){
      const eventInput = normalizeNumber(input.toString())
      return Number(eventInput)
    },
    input(event: any){
      this.$emit('input', this.maxValidate(this.formatInput(event.target.value)))
    },
    validateNumberInput(input: any) {
      if (isNaN(Number(this.formatInput(input.key)))) {
        return input.preventDefault()
      }
    }
  }
})
